// Códigos de erro de sessão devolvidos pelo backend em `data.code`.
// Contrato `contrato-isolamento-usuario-tenant` (store `partnercenter-specs`): reconhecer só pelo código, nunca pela mensagem.

// Usuário autenticado cujo owner não é o do domínio acessado: a sessão não vale aqui.
export const USUARIO_SEM_ACESSO_OWNER = 'USUARIO_SEM_ACESSO_OWNER'

export function isErroSemAcessoOwner(error) {
  return error?.response?.status === 403 && error.response.data?.data?.code === USUARIO_SEM_ACESSO_OWNER
}

// Falta de permissão (contrato `contrato-erro-permissao-especifica`): `message` já nomeia a permissão exigida.
export const PERMISSAO_NEGADA = 'PERMISSAO_NEGADA'

// `message` do corpo de erro quando é um texto utilizável; `null` caso contrário.
export function mensagemDoErro(error) {
  const message = error?.response?.data?.message
  return typeof message === 'string' && message.trim() ? message : null
}
